export default __webpack_public_path__ + "static/media/bg_innovation.9ae971cf.png";